// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
  color: #247dad;
}

.notification-menu-header {
  padding-top: 8px;
  padding-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #f1f4f6;
}
.notification-menu-header span.title {
  cursor: default;
  letter-spacing: 0.1em;
  font-weight: bolder;
  font-size: 1em;
}

.notification-menu-footer {
  padding-top: 8px;
  padding-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #f1f4f6;
}

.notification-menu-content {
  max-height: 296px;
  overflow-y: scroll;
  width: 100%;
}

.mat-mdc-menu-item {
  cursor: default;
}

.notification-configuration-container {
  display: flex;
  flex-direction: column;
  margin: 10px;
}
.notification-configuration-container .notification-configuration-content {
  display: flex;
  flex-direction: column;
  margin: 5px 0;
}

::ng-deep .my-mat-tab .mat-mdc-tab-list {
  border-bottom: solid 1px #e0e0e0;
}

::ng-deep .my-mat-tabb .mdc-tab.mat-mdc-tab.mdc-tab--active {
  border: solid 1px #e0e0e0 !important;
  border-radius: 10px !important;
  box-shadow: none !important;
  width: auto !important;
  padding-left: 40px !important;
  padding-right: 40px !important;
  height: 49px !important;
}
::ng-deep .my-mat-tabb .mdc-tab.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: black !important;
  letter-spacing: normal !important;
}

::ng-deep .mat-mdc-menu-item-text {
  font-size: 14px !important;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/notifications/notification-menu/notification-menu.component.scss"],"names":[],"mappings":"AACA;EACE,cAAA;AAAF;;AAGA;EAOE,gBAZc;EAad,mBAbc;EAcd,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;AANF;AALE;EACE,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;AAOJ;;AAGA;EACE,gBArBc;EAsBd,mBAtBc;EAuBd,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AAAF;;AAGA;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAAF;AAEE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AAAJ;;AAGA;EACE,gCAAA;AAAF;;AAEA;EACE,oCAAA;EACA,8BAAA;EACA,2BAAA;EACA,sBAAA;EACA,6BAAA;EACA,8BAAA;EACA,uBAAA;AACF;AAAE;EACE,uBAAA;EACA,iCAAA;AAEJ;;AACA;EACE,0BAAA;AAEF;;AAAA;EACE,kCAAA;AAGF","sourcesContent":["$extra-padding: 8px;\r\na {\r\n  color: #247dad;\r\n}\r\n\r\n.notification-menu-header {\r\n  span.title {\r\n    cursor: default;\r\n    letter-spacing: 0.1em;\r\n    font-weight: bolder;\r\n    font-size: 1em;\r\n  }\r\n  padding-top: $extra-padding;\r\n  padding-bottom: $extra-padding;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-bottom: 1px solid #f1f4f6;\r\n}\r\n\r\n.notification-menu-footer {\r\n  padding-top: $extra-padding;\r\n  padding-bottom: $extra-padding;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-top: 1px solid #f1f4f6;\r\n}\r\n\r\n.notification-menu-content {\r\n  max-height: 296px;\r\n  overflow-y: scroll;\r\n  width: 100%;\r\n}\r\n\r\n.mat-mdc-menu-item {\r\n  cursor: default;\r\n}\r\n\r\n.notification-configuration-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 10px;\r\n\r\n  .notification-configuration-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin: 5px 0;\r\n  }\r\n}\r\n::ng-deep .my-mat-tab .mat-mdc-tab-list {\r\n  border-bottom: solid 1px #e0e0e0;\r\n}\r\n::ng-deep .my-mat-tabb .mdc-tab.mat-mdc-tab.mdc-tab--active {\r\n  border: solid 1px #e0e0e0 !important;\r\n  border-radius: 10px !important;\r\n  box-shadow: none !important;\r\n  width: auto !important;\r\n  padding-left: 40px !important;\r\n  padding-right: 40px !important;\r\n  height: 49px !important;\r\n  .mdc-tab__text-label {\r\n    color: black !important;\r\n    letter-spacing: normal !important;\r\n  }\r\n}\r\n::ng-deep .mat-mdc-menu-item-text {\r\n  font-size: 14px !important;\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
